import { render, staticRenderFns } from "./bxYxxsc.vue?vue&type=template&id=61cccc98&scoped=true"
import script from "./bxYxxsc.vue?vue&type=script&lang=js"
export * from "./bxYxxsc.vue?vue&type=script&lang=js"
import style0 from "./bxYxxsc.vue?vue&type=style&index=0&id=61cccc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cccc98",
  null
  
)

export default component.exports